import React from "react";
import PropTypes from "prop-types";

const LoadingFormNormal = props => {
  const numInput = Number(props.countInput);
  const numButton = Number(props.countButton);
  return (
    <React.Fragment>
      <div className={`row ${props.formClass}`}>
        {[...Array(numInput)].map((x, i) => (
          <div key={i} className="col mb-3">
            <div className="row row-cols-1 m-0 placeholder-glow">
              <div className="col-3 placeholder bg-secondary mb-1 placeholder-lg pt-4"></div>
              <div className="col placeholder placeholder-lg bg-info py-3"></div>
            </div>
          </div>
        ))}
      </div>
      <div className={`row ${props.buttonClass}`}>
        {[...Array(numButton)].map((x, i) => (
          <div key={i} className={props.buttonColClass}>
            <button className="btn btn-primary disabled placeholder w-100"></button>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

LoadingFormNormal.propTypes = {
  countInput: PropTypes.string,
  countButton: PropTypes.string,
  buttonClass: PropTypes.string,
  buttonColClass: PropTypes.string,
  formClass: PropTypes.string,
};

LoadingFormNormal.defaultProps = {
  countInput: "5",
  countButton: "1",
  buttonClass: "justify-content-start",
  buttonColClass: "col-3",
  formClass: "row-cols-1 row-cols-md-2",
};

export default LoadingFormNormal;
